import "./notification.scss"

class NotificationLib {
	
	constructor() {
		this.stylesInjectedId = 'global-notification-styles';
		this.containerId = 'global-notification-container';
	}
	
	ensureContainer() {
		let container = document.getElementById(this.containerId);
		if (!container) {
			container = document.createElement('div');
			container.id = this.containerId;
			container.style.position = 'fixed';
			container.style.bottom = '20px';
			container.style.right = '20px';
			container.style.left = 'auto';
			container.style.transform = 'none';
			container.style.zIndex = '9999';
			container.style.display = 'flex';
			container.style.flexDirection = 'column';
			container.style.alignItems = 'flex-end';
			container.style.pointerEvents = 'none';
			document.body.appendChild(container);
		}
		return container;
	}
	
	createNotification(type, message, duration = 4000) {
		const container = this.ensureContainer();
		const div = document.createElement('div');
		div.className = `notification ${type}`;
		div.innerText = message;
		
		container.appendChild(div);
		
		if (type !== 'permanent') {
			setTimeout(() => div.remove(), duration);
		}
		
		return div;
	}
	
	dismissAll() {
		const container = document.getElementById(this.containerId);
		if (container) {
			container.innerHTML = '';
		}
	}
	
	customAlert(message) {
		const overlay = document.createElement('div');
		overlay.className = 'notification-overlay';
		
		const modal = document.createElement('div');
		modal.className = 'notification-modal';
		modal.innerHTML = `<div>${message}</div>`;
		
		const okBtn = document.createElement('button');
		okBtn.innerText = 'OK';
		okBtn.onclick = () => document.body.removeChild(overlay);
		
		modal.appendChild(okBtn);
		overlay.appendChild(modal);
		document.body.appendChild(overlay);
	}
	
	customConfirm(message, callback) {
		const overlay = document.createElement('div');
		overlay.className = 'notification-overlay';
		
		const modal = document.createElement('div');
		modal.className = 'notification-modal';
		modal.innerHTML = `<div>${message}</div>`;
		
		const yesBtn = document.createElement('button');
		yesBtn.innerText = 'Yes';
		yesBtn.onclick = () => {
			document.body.removeChild(overlay);
			callback(true);
		};
		
		const noBtn = document.createElement('button');
		noBtn.innerText = 'No';
		noBtn.onclick = () => {
			document.body.removeChild(overlay);
			callback(false);
		};
		
		modal.appendChild(yesBtn);
		modal.appendChild(noBtn);
		overlay.appendChild(modal);
		document.body.appendChild(overlay);
	}
	
	// Create the NotificationLib object
	notify = this.createNotification;
	alert = this.customAlert;
	confirm = this.customConfirm;
	
	// NotificationLib = {
	// 	notify: createNotification,
	// 	dismissAll,
	// 	alert: customAlert,
	// 	confirm: customConfirm,
	// };
	
}

export {
	NotificationLib
}